export const SET_USER_DATA = "SET_USER_DATA"
export const DELETE_USER_DATA = "DELETE_USER_DATA"
